import React from "react";
import { Grid, Card, CardContent, Typography, Box } from "@material-ui/core";
import TrendingUpIcon from '@material-ui/icons/TrendingUp';
import BarChartIcon from '@material-ui/icons/BarChart';
import EmojiEventsIcon from '@material-ui/icons/EmojiEvents';
import { formatNota } from "../../utils/formato";

const TarjetasResumen = ({ metrics, seleccionado }) => {
  const promedioLabel = seleccionado && metrics?.promedio != null ? formatNota(metrics.promedio) : "";
  const desviacionLabel = seleccionado && metrics?.desviacion != null ? metrics.desviacion.toFixed(2) : "";
  const competenciaLabel = seleccionado ? metrics?.competenciaLabel || "" : "";
  const cardStyle = { borderRadius: 12, minHeight: 64 };

  return (
    <Grid container spacing={1}>
      <Grid item xs={12} sm={6} md={4}>
        <Card elevation={2} style={cardStyle}>
          <CardContent style={{ display: 'flex', flexDirection: 'column', justifyContent: 'space-between', height: '100%', padding: '8px 10px' }}>
            <Box display="flex" alignItems="center" justifyContent="space-between" mb={0.25}>
              <Typography variant="body2" color="textSecondary" style={{ fontWeight: 700 }}>
                Promedio general
              </Typography>
              <BarChartIcon color="primary" fontSize="medium" />
            </Box>
            <Typography variant="body1" style={{ marginTop: 2, fontWeight: 700 }}>
              {promedioLabel}
            </Typography>
          </CardContent>
        </Card>
      </Grid>

      <Grid item xs={12} sm={6} md={4}>
        <Card elevation={2} style={cardStyle}>
          <CardContent style={{ display: 'flex', flexDirection: 'column', justifyContent: 'space-between', height: '100%', padding: '8px 10px' }}>
            <Box display="flex" alignItems="center" justifyContent="space-between" mb={0.25}>
              <Typography variant="body2" color="textSecondary" style={{ fontWeight: 700 }}>
                Desviación estándar
              </Typography>
              <TrendingUpIcon style={{ color: '#f59e0b' }} fontSize="medium" />
            </Box>
            <Typography variant="body1" style={{ marginTop: 2, fontWeight: 700 }}>
              {desviacionLabel}
            </Typography>
          </CardContent>
        </Card>
      </Grid>

      <Grid item xs={12} md={4}>
        <Card elevation={2} style={cardStyle}>
          <CardContent style={{ display: 'flex', flexDirection: 'column', justifyContent: 'space-between', height: '100%', padding: '8px 10px' }}>
            <Box display="flex" alignItems="center" justifyContent="space-between" mb={0.25}>
              <Typography variant="body2" color="textSecondary" style={{ fontWeight: 700 }}>
                Mejor competencia
              </Typography>
              <EmojiEventsIcon style={{ color: '#22c55e' }} fontSize="medium" />
            </Box>
            <Typography variant="body1" component="div" style={{ marginTop: 2, fontWeight: 'bold' }}>
              {competenciaLabel}
            </Typography>
          </CardContent>
        </Card>
      </Grid>
    </Grid>
  );
};

export default TarjetasResumen;